var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-card',[_c('div',{staticClass:"text-center",attrs:{"data-test":"mortgagee.lienholderBilled"}},[_vm._v("Your Mortgagee Lienholder will be billed for your policy.")]),_c('div',{staticClass:"text-center"},[_vm._v(" If you would still like to make a payment please select a payment type above. ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }